<template>
  <b-container class="mt-5 gases-limit" fluid>
    <b-row align-v="center" class="gases-limit__fixed-header">
      <b-col
        class="text-center gases-limit__header p-3"
        cols="7"
      >
        <label class="mb-0">
          {{ $t('engineering.chromatography.method-parameters.gas') }}
        </label>
      </b-col>
      <b-col
        class="text-center gases-limit__header p-3"
        cols="5"
      >
        <label class="mb-0">
          {{ $t('engineering.chromatography.method-parameters.limit') }}
          <sup>
            <info-badge
              placement="topleft"
              translation-key="messages.MI015.message"
            />
          </sup>
        </label>
      </b-col>
    </b-row>
    <b-row class="gases-limit__body px-0 mt-1">
      <b-col v-if="!parametersCopy">
        <s-empty-list/>
      </b-col>
      <b-col v-else cols="12">
        <b-row
          v-for="({ label, key }, index) in labels"
          :key="index" class="gases-limit__rows"
          align-v="center"
        >
          <b-col cols="7" class="gases-limit__border  p-3">
            <label class="mb-0">
              {{ label }}
            </label>
          </b-col>
          <b-col
            cols="5"
            class="gases-limit__border text-center p-3"
          >
            <s-input-label-edit
              class="gases-limit__field text-center"
              v-model="gasesLimit[key]"
              :editable="editMode"
              :formatted-value="formatNumberValue(gasesLimit[key], 1, 1)"
            >
              <s-number-input
                v-model="gasesLimit[key]"
                :numeric-options="inputNumericOptions"
                :validation="getValidation(key).validation"
                :invalid="getValidation(key).invalid"
              />
              <b-form-invalid-feedback id="input-live-feedback">
                {{ $t('messages.MA086.message', getValueRange(key))  }}
              </b-form-invalid-feedback>
            </s-input-label-edit>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import InfoBadge from '@/components/icon/InfoBadge';
import duvalParametersLabels from '@/domain/data/installation/engineering/chromatography/methodsParameters/duvalParametersLabels';

export default {
  name: 'GasesLimit',
  components: {
    InfoBadge,
  },
  props: {
    parametersCopy: {
      type: Object,
      required: true,
    },
    validation: {
      type: Object,
      required: true,
    },
    editMode: {
      type: Boolean,
      required: true,
    },
  },
  data: vm => ({
    labels: duvalParametersLabels(vm),
  }),
  computed: {
    parametersCopyProxy: {
      get() {
        return this.parametersCopy;
      },
      set(value) {
        this.$emit('update:parameters-copy', value);
      },
    },
    gasesLimit: {
      get() {
        return this.parametersCopyProxy?.gasesLimit || {};
      },
      set(value) {
        this.parametersCopyProxy.gasesLimit = value;
      },
    },
    inputNumericOptions() {
      return {
        decimalPlaces: 1,
      };
    },
  },
  methods: {
    getValueRange(key) {
      const params = this.getValidation(key).validation?.$params || {};
      return {
        minValue: params?.minValue?.min || 0,
        maxValue: params?.maxValue?.max || 1000000,
      };
    },
    getValidation(key) {
      const validation = this.validation.parametersCopy;
      if (!validation || !validation.gasesLimit) return { validation: null, invalid: null };
      const validationObject = validation.gasesLimit[key] || {};
      return {
        validation: validationObject,
        invalid: validationObject.$invalid,
      };
    },
    formatNumberValue(value, minimumFractionDigits = 0, maximumFractionDigits = 0) {
      if (typeof value !== 'number') {
        return value;
      }
      return this.$n(value, { minimumFractionDigits, maximumFractionDigits });
    },
  },
};
</script>

<style lang="sass" scoped>
@import "src/styles/defaults/mobile-first"

.gases-limit
  overflow: auto
  &__fixed-header
    display: flex
    flex-direction: row
    flex-wrap: nowrap
    position: sticky
    top: 0
    z-index: 10
  &__header
    min-width: 200px
    background: var(--color-table-body-bg)
    &:nth-child(2n)
      background: var(--color-table-header-bg)
  &__title-text
    height: 1.5em
  &__body
    border: 1px solid var(--color-border-select)
    border-radius: 5px
    overflow: auto
    width: min-content
  &__border
    border-right: 1px solid var(--color-table-body-bg)
    min-width: 200px
    &:nth-child(2n)
      border-left: 1px solid white
      border-right: 0
  &__title-icon
    margin-top: -1.5em
    height: 1.5em
  &__rows
    display: flex
    flex-direction: row
    flex-wrap: nowrap
    &:nth-child(2n)
      background: var(--color-table-body-accent-bg)
  &__loader
    height: 300px
  ::v-deep
    .btn
      padding: 0 !important
  +media-min-lg()
    &__body
      width: auto
</style>
